
/**
 * Ensures a date string is parsed as UTC.
 * The API returns timezone-naive ISO strings (e.g. "2026-04-18T10:00:00")
 * which `new Date()` interprets as local time. Appending "Z" forces UTC
 * so the wall-clock time survives JSON serialization round-trips.
 *
 * HRS-2658: strings that already carry a timezone — "Z" or a "+HH:MM"/"-HH:MM"
 * offset (e.g. "2026-07-19T14:00:00+00:00", emitted by the backend's
 * hour-rounding) — must be parsed as-is: appending "Z" after an offset
 * ("...+00:00Z") yields an Invalid Date, which serializes to null and breaks
 * sync-route.
 */
export const parseAsUTC = (value: string | Date): Date => {
  if (value instanceof Date) return value;
  if (value.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(value)) return new Date(value);
  return new Date(value + 'Z');
};